import { Box, Grid } from '@mui/material';
import { ProfileView } from 'components/ui/Account/ProfileView';
import { ResponsibleList } from 'components/ui/Account/ResponsibleList';
import { IWorkRoleViewModel } from 'data/atoms/atomConfig';
import userAtom from 'data/atoms/userAtom';
import { useAtom } from 'jotai';
import React, { useEffect, useReducer } from 'react';

interface State {
  workRole: IWorkRoleViewModel;
  workRoles: IWorkRoleViewModel[];
}

// Action type definition

// Initial state

const reducer = (state: any, action: any) => {
  //console.log("reducer", state, action);
  switch (action.type) {
    case 'CHANGE_WORK_ROLE':
      return {
        ...state,
        workRole: action.workRole,
      };
    default:
      return null;
  }
};

export const AccountPage: React.FC = () => {
  const [user] = useAtom(userAtom);

  const initialState: State = {
    workRole: {} as IWorkRoleViewModel,
    workRoles: [],
  };

  // STATE
  const [state, dispatch] = useReducer(reducer, initialState);


  // EFFECT
  useEffect(() => {
    // Update state when user is available
    if (user) {
      dispatch({ type: 'CHANGE_WORK_ROLE', workRole: user.workRole || {} });
    }
  }, [user]);

  // HANDLERS

  return (
    <Grid container spacing={2} flexGrow={1} direction={'row'}>
      {/* LEFT SIDE */}
      <Grid item xs={6}>
        <Grid container flexGrow={1} direction={'row'}>
          <ProfileView user={user} />
          {/* WORK ROLE */}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}></Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'success.main',
                color: 'secondary.Text',
              }}
            >
              HOLIDAY REQUEST
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'warning.main',
                color: 'warning.Text',
              }}
            >
              SICK STATUS
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'info.main',
                color: 'info.Text',
              }}
            >
              SCHEDULED TIME REMINDERS
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'error.main',
                color: 'primary.dark',
              }}
            >
              PRODUCTS
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <Box
              sx={{
                width: '100%',
                backgroundColor: 'primary.main',
                color: 'primary.contrastText',
              }}
            >
              ACTION LIST
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
        <ResponsibleList />
      </Grid>
    </Grid>
  );
};
